module.exports = __webpack_public_path__ + "static/media/73.6ec1986.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/73.wav
// module id = vKUH
// module chunks = 0